class ProductGallery extends Carousel {
  constructor() {
    super();
    this.variantFilter =
      this.carouselElement.dataset["variantfilter"] === "true" || false;
  }

  connectedCallback() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      this.variantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        ({ data }) => {
          if (data && data.variant) {
            const featuredMedia = data.variant.featured_media || data.variant.featured_image;
            if (featuredMedia) {
              this.setActiveMedia(featuredMedia);
            }
          }
        }
      );
    }
  }

  disconnectedCallback() {
    this.variantChangeUnsubscriber?.();
  }

  showAllMedia() {
    let allItems = this.carouselElement.querySelectorAll("[data-filter]");
    let allThumbnailItems = this.syncElement ? this.syncElement.querySelectorAll("[data-filter]") : [];

    allItems.forEach((element) => {
      element.classList.add("splide__slide");
      element.classList.remove("hidden");
    });

    allThumbnailItems.forEach((element) => {
      element.classList.add("splide__slide");
      element.classList.remove("hidden");
    });

    this.refreshSlider();
  }

  filterMedia(media) {
    this.showAllMedia();

    let filterSlides = this.carouselElement.querySelectorAll(
      `[data-filter]:not([data-filter="${media?.alt}"])`
    );
    let filterSlidesThumbnails = this.syncElement
      ? this.syncElement.querySelectorAll(
          `[data-filter]:not([data-filter="${media?.alt}"])`
        )
      : [];

    filterSlides.forEach((element) => {
      element.classList.remove("splide__slide");
      element.classList.add("hidden");
    });

    filterSlidesThumbnails.forEach((element) => {
      element.classList.remove("splide__slide");
      element.classList.add("hidden");
    });
    this.refreshSlider();
  }

  setActiveMedia(media) {
    if (!media) return;
    if (typeof media === 'string' || typeof media === 'number') {
      const mediaId = String(media).replace(/^[^-]+-/, '');
      media = { id: mediaId };
    }
    const mediaId = media?.id;

    if (this.variantFilter && media?.alt) {
      this.filterMedia(media);
    }

    if (this.carousel && this.carousel.Components && this.carousel.Components.Slides) {
      let Slides = this.carousel.Components.Slides.filter(
        `li[data-media-id="${mediaId}"]:not(.splide__slide--clone)`
      );
      if (Slides && Slides[0]) {
        this.refreshSlider();
        this.carousel.go(Slides[0].index);
      }
    }
  }
}

customElements.define("product-gallery", ProductGallery);